module.exports = __webpack_public_path__ + "img/faq.90290c16.png";